import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { featuredTestimonial, testimonials } from '../data/testimonials';
import { offer } from '../data/offer';
const stats = [{
  label: 'Students from Bangladesh',
  value: offer.studentCount
}, {
  label: 'Satisfaction rate',
  value: offer.satisfaction
}, {
  label: 'Money-back guarantee',
  value: '7 days'
}];
export function SocialProof() {
  return <section aria-labelledby="proof-heading" className="border-y border-white/10 bg-navy-900" data-id="element-145" data-mp="3ebo3fpxy00o">
      <div className="mx-auto max-w-content px-4 py-10 sm:px-6 lg:py-12" data-id="element-146" data-mp="8ehfcusatki8">
        <h2 id="proof-heading" className="max-w-2xl font-display text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-147" data-mp="3pufuau9uik1b">
          Join {offer.studentCount} Students From Bangladesh Already Transforming Their
          Lives
        </h2>

        <div className="mt-8 grid gap-4 lg:grid-cols-3" data-id="element-148" data-mp="mc63qclkr9s1">
          <figure className="flex h-full flex-col rounded-xl border border-celeste-500/30 bg-navy-800 p-6 lg:col-span-2" data-id="element-149" data-mp="r4z82zd4sg3l">
            <QuoteIcon className="h-6 w-6 text-celeste-500" aria-hidden="true" data-id="element-150" data-mp="1uawcbiezjt3l" />
            <blockquote className="mt-4 font-display text-base font-semibold leading-snug text-white sm:text-lg" data-id="element-151" data-mp="1pb9wr2boq0rm">
              &ldquo;{featuredTestimonial.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-152" data-mp="1z8eaqevdmpxc">
              <img src={featuredTestimonial.avatar} alt={`Portrait of ${featuredTestimonial.name}`} width={44} height={44} loading="lazy" decoding="async" className="h-11 w-11 rounded-full object-cover" data-id="element-153" data-mp="2d0cesba8dvmn" />
              <div data-id="element-154" data-mp="2myid6iwtwjmr">
                <p className="text-sm font-semibold text-white" data-id="element-155" data-mp="2mz1vi0qe5a1b">
                  {featuredTestimonial.name}
                  <span className="font-normal text-white/55" data-id="element-156" data-mp="2i0gx86up90fi">
                    {' '}
                    · {featuredTestimonial.location}
                  </span>
                </p>
                <p className="mt-0.5 text-[13px] font-semibold text-celeste-300" data-id="element-157" data-mp="nlxsdxmoqkub">
                  {featuredTestimonial.role}
                </p>
              </div>
            </figcaption>
          </figure>

          <dl className="flex h-full flex-col justify-center gap-5 rounded-xl border border-white/10 bg-navy-800/50 p-6" data-id="element-158" data-mp="1hadhehrtr9rp">
            {stats.map(stat => <div key={stat.label} data-id="element-159" data-mp="1mcb5pqf30uri">
                <dt className="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/45" data-id="element-160" data-mp="1r91hw2nrn67n">
                  {stat.label}
                </dt>
                <dd className="mt-0.5 font-display text-2xl font-extrabold tabular-nums text-white sm:text-3xl" data-id="element-161" data-mp="1w85t0yu93e0m">
                  {stat.value}
                </dd>
              </div>)}
          </dl>
        </div>

        <div className="mt-4 grid gap-4 md:grid-cols-3" data-id="element-162" data-mp="252stdgl25060">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-xl border border-white/10 bg-navy-800/60 p-5" data-id="element-163" data-mp="29z15sm7vef9h">
              <blockquote className="text-[13px] leading-relaxed text-white/80" data-id="element-164" data-mp="2ex2oh61dwckf">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-165" data-mp="8boljn73ajn1">
                <img src={item.avatar} alt={`Portrait of ${item.name}`} width={36} height={36} loading="lazy" decoding="async" className="h-9 w-9 shrink-0 rounded-full object-cover" data-id="element-166" data-mp="3b0skvzavsq6" />
                <div className="min-w-0" data-id="element-167" data-mp="3pj0djznf9mqu">
                  <p className="text-[13px] font-semibold text-white" data-id="element-168" data-mp="3pk20b1dsvxoe">
                    {item.name}
                    <span className="font-normal text-white/55" data-id="element-169" data-mp="r0ldhkf0l023"> · {item.location}</span>
                  </p>
                  <p className="text-[13px] text-celeste-300" data-id="element-170" data-mp="m2tmcsm71hyy">{item.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}